export class Tag {
  static type = 'tag'

  type = Tag.type

  get guid () {
    return this.slug
  }

  slug?: string

  name?: string
}
